export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-2048w.894220e8.png";